import { defineStore } from 'pinia';

import {
  SystemSettingRepository,
  SystemSettingResponse,
} from '@/repositories/generated';

type SystemSettingState = Partial<{
  systemSetting: SystemSettingResponse;
}>;

export const useSystemSettingStore = defineStore('systemSetting', {
  state: (): SystemSettingState => ({
    systemSetting: undefined,
  }),
  actions: {
    async getSystemSetting(): Promise<SystemSettingResponse> {
      if (this.systemSetting != null) {
        return this.systemSetting;
      }

      this.systemSetting = (await SystemSettingRepository.systemSetting()) as SystemSettingResponse;

      return this.systemSetting;
    },
  },
});
